import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

export default BookmarkBorderIcon;
